const types = {
  DELETE: 'delete',
  SAVE: 'save'
};

export default types;